/** User/header setting: Annual | Monthly | Recurring (default), plus legacy boolean monthly flag. */
export const normalizeRecurringHeaderType = (quoteRecurringType) => {
	if (quoteRecurringType === "Annual" || quoteRecurringType === "Monthly") {
		return quoteRecurringType;
	}
	if (quoteRecurringType === true || quoteRecurringType === "true") {
		return "Monthly";
	}
	return "Recurring";
};

const isMonthlyRecurringTermType = (defaultRecurringTermType) => {
	const normalized = String(defaultRecurringTermType ?? "").toLowerCase();
	return normalized.includes("month");
};

/**
 * Annual vs monthly cycle used for recurring gross profit / margin (and non-excluded pairs).
 * Explicit header modes use that mode; Default follows the quote default recurring term type.
 */
export const resolveRecurringMarginPeriod = (headerType, quote) => {
	if (headerType === "Annual" || headerType === "Monthly") {
		return headerType;
	}
	return isMonthlyRecurringTermType(quote?.DefaultRecurringTermType) ? "Monthly" : "Annual";
};

export const getRecurringGrossProfitForPeriod = (quote, period) => {
	if (period === "Annual") {
		return quote?.AnnualRecurringGrossProfit;
	}
	if (period === "Monthly") {
		return quote?.MonthlyRecurringGrossProfit;
	}
	return quote?.RecurringGrossMarginAmount;
};

/** Raw margin % for comparisons (matches server Math.Round to 2 decimals). */
export const getRecurringGrossMarginForPeriod = (quote, period) => {
	if (period === "Annual") {
		return quote?.AnnualRecurringGrossMargin;
	}
	if (period === "Monthly") {
		return quote?.MonthlyRecurringGrossMargin;
	}
	return quote?.RecurringGrossMargin ?? quote?.PrintedRecurringGrossMargin;
};

export const getNonExcludedRecurringGrossProfitForPeriod = (quote, period) => {
	if (period === "Monthly") {
		return quote?.NonExcludedMonthlyRecurringGrossProfit;
	}
	return quote?.NonExcludedAnnualRecurringGrossProfit;
};

export const getNonExcludedRecurringGrossMarginForPeriod = (quote, period) => {
	if (period === "Monthly") {
		return quote?.NonExcludedMonthlyRecurringGrossMargin;
	}
	return quote?.NonExcludedAnnualRecurringGrossMargin;
};

export const getNonExcludedRecurringGrossMarginDisplayForPeriod = (quote, period) => {
	if (period === "Monthly") {
		return quote?.PrintedNonExcludedMonthlyRecurringGrossMargin;
	}
	return quote?.PrintedNonExcludedAnnualRecurringGrossMargin;
};
